
    import {computed, ComputedRef, defineComponent, reactive, watch} from 'vue'
    import componentTitle from './componentTitle.vue';
    import {useStore} from "@/store";
    import {useRoute} from "vue-router"
    import utils from '@/util/index';
    interface State {
        queryModules: object[];
    }
    export default defineComponent({
        name: 'entrustQuery',
        setup() {
            let state: State = reactive({
                queryModules: []
            })
            let store = useStore()
            let dataInfo: ComputedRef<{}> = computed<{}>(() => store.state.dataInfo)
            watch(dataInfo,(data: any) => {
                const {queryModules} = data;
                state.queryModules = queryModules || [];
            })
            function haveScore(item: any): boolean {
                if(item && item.score && item.score.length > 0){
                    return true;
                }else {
                    return false;
                }
            }
            function changeLevelClass(item: any): string {
                if (item && item.status === 0) {
                    return 'entrustQueryLevel level2';
                } else if (item && item.status === 1) {
                    return 'entrustQueryLevel level1';
                } else {
                    return 'entrustQueryLevel';
                }
            }
            function getLevelDes(item: any): string {
                if (item && item.score && item.status === 0) {
                    return '正常';
                } else if (item && item.score && item.status === 1) {
                    return '较差';
                } else {
                    return '';
                }
            }
            function getScoreDes(item: any): string {
                if (item && item.score && item.score.length > 0) {
                    return item.score + '分';
                } else  {
                    return '查看查询报告';
                } 
            }
            return {
                state,
                haveScore,
                changeLevelClass,
                getLevelDes,
                getScoreDes,
            }
        },
        methods: {
            goToView (item: any) {
                window.location.href=(item && item.reportUrl) || '';
            }
        },
        components: {
            componentTitle
        },
        
    })
